// Generated by `pnpm gen:svg` from src/assets/svg — do not edit.
import type { SVGProps } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  ref?: Ref<SVGSVGElement>;
}
const SvgSunglasses = ({
  title,
  titleId,
  ref,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    id="Vrstva_1"
    data-name="Vrstva 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="309 193 220 220"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <defs>
      <style>{`
.sg-1 {
  stroke: var(--mascot-accent, #ff49a4);
}

.sg-1,
.sg-2,
.sg-3,
.sg-4 {
  stroke-miterlimit: 10;
}

.sg-1,
.sg-4 {
  stroke-width: 2px;
}

.sg-2 {
  stroke: #fff;
  stroke-width: 0.25px;
}

.sg-5 {
  fill: #fff;
}

.sg-6 {
  fill: #484747;
}

.sg-3 {
  stroke: #000;
  stroke-width: 0.5px;
}

.sg-4 {
  fill: none;
  opacity: 0.44;
  stroke: #f4f4f4;
}

.sg-7 {
  fill: var(--mascot-accent, #ff49a4);
  opacity: 0.4;
}
`}</style>
    </defs>
    <path
      className="sg-5"
      d="M524.87,308.06c0,35.48-17.52,66.86-44.39,85.97-1.75,1.24-3.53,2.43-5.35,3.56-13.76,8.58-29.64,14.08-46.68,15.51-2.97.26-5.97.39-9.01.39-1.48,0-2.96-.03-4.43-.1-19.65-.8-37.91-6.99-53.35-17.14-.25-.17-.51-.33-.76-.51-28.26-18.9-46.88-51.12-46.88-87.68,0-58.22,47.2-105.43,105.42-105.43s105.43,47.21,105.43,105.43Z"
    />
    <path
      className="sg-7"
      d="M524.87,308.06c0,35.48-17.52,66.86-44.39,85.97-1.75,1.24-3.53,2.43-5.35,3.56-13.76,8.58-29.64,14.08-46.68,15.51-2.97.26-5.97.39-9.01.39-1.48,0-2.96-.03-4.43-.1-19.65-.8-37.91-6.99-53.35-17.14-.25-.17-.51-.33-.76-.51-28.26-18.9-46.88-51.12-46.88-87.68,0-58.22,47.2-105.43,105.42-105.43s105.43,47.21,105.43,105.43Z"
    />
    <path d="M340.86,349.81c-.6-1.92,6.89-11.29,12.09-17.64,5.19-6.32,10.76-13.29,16.39-18.73,2.3-2.24,5.66-5.29,8.79-8.09.69-.64,1.36-1.25,2.01-1.83,2.17-1.92,4.07-3.6,5.25-4.63.79-.7,1.24-1.1,1.24-1.1,0,0,1.43,12.61.72,18.21-.02.18-.04.33-.08.49-.77,5.56-3,12.99-7.21,18.05-.73.87-1.47,1.67-2.25,2.41-.47.44-.94.89-1.44,1.3-.45.4-.98.8-1.54,1.23-.71.57-1.44,1.1-2.18,1.65-.11.07-.22.16-.33.25-.3.21-.57.41-.86.62-1.63,1.14-3.28,2.31-4.96,3.66-.25.18-.48.38-.71.57-.28.25-.54.46-.8.68-5.38,4.67-12.97,12.01-14.93,11.32-1.97-.71-8.61-6.49-9.2-8.42Z" />
    <path d="M497.39,350.55c.6-1.92-6.89-11.29-12.09-17.64-5.19-6.32-10.76-13.29-16.39-18.73-2.3-2.24-5.66-5.29-8.79-8.09-.69-.64-1.36-1.25-2.01-1.83-2.17-1.92-4.07-3.6-5.25-4.63-.79-.7-1.24-1.1-1.24-1.1,0,0-1.43,12.61-.72,18.21.02.18.04.33.08.49.77,5.56,3,12.99,7.21,18.05.73.87,1.47,1.67,2.25,2.41.47.44.94.89,1.44,1.3.45.4.98.8,1.54,1.23.71.57,1.44,1.1,2.18,1.65.11.07.22.16.33.25.3.21.57.41.86.62,1.63,1.14,3.28,2.31,4.96,3.66.25.18.48.38.71.57.28.25.54.46.8.68,5.38,4.67,12.97,12.01,14.93,11.32,1.97-.71,8.61-6.49,9.2-8.42Z" />
    <path
      className="sg-5"
      d="M475.13,397.59c-13.76,8.58-29.64,14.08-46.68,15.51-2.97.26-5.97.39-9.01.39-1.48,0-2.96-.03-4.43-.1-19.65-.8-37.91-6.99-53.35-17.14-.25-.17-.51-.33-.76-.51-2.2-9.34-2.59-19.45-.58-29.91,1.21-6.32,2.62-12.53,4.24-18.53.85-3.17,1.77-6.28,2.75-9.32.03-.12.07-.24.11-.36,4.86-15.09,11.22-28.38,19.39-38,.01-.02.02-.04.03-.05,8.47-9.99,18.87-16.03,31.52-16.08h.15c13.18,0,24.12,6.26,32.94,16.74.07.09.15.18.22.27,7.66,9.21,13.71,21.62,18.22,35.89,1.13,3.56,2.16,7.24,3.09,11.02,1.48,5.93,2.71,12.1,3.72,18.42,1.79,11.19,1.04,21.94-1.57,31.76Z"
    />
    <path
      className="sg-3"
      d="M469.57,336.39c-9.13,18.67-28.78,31.59-51.54,31.59s-41.55-12.36-50.92-30.36c9.92-30.85,26.14-54.13,51.09-54.13s41.65,22.11,51.38,52.9Z"
    />
    <path
      className="sg-2"
      d="M455.27,291.54s.07-.01.07-.01c-4.91,15.48-15.47,25.58-18.8,36.67-4.45,14.78-5.8,29.99-7.06,31.36-2.53,2.72-17.7,2.72-21.06,0-1.69-1.37-1.17-15.8-6.21-28.93-5.73-14.88-6.54-17.1-13.9-28.51.01-.03.03-.07.07-.1-4.45-6.79-10.71-19.39-10.71-30.86,0-25.65,18.32-46.44,40.88-46.44s40.88,20.79,40.88,46.44c0,7.32-1.49,14.23-4.15,20.38Z"
    />
    <path
      className="sg-6"
      d="M395.27,233.96c-4.16,3.42-8.07,7.63-10.87,12.53-3.64-1.75-7.4-4.15-7.93-6.68-.99-4.67,1.03-9.55,3.99-11.54,2.95-1.99,5.59-2.08,9.05-1.19,1.69.42,3.93,3.68,5.76,6.88Z"
    />
    <path
      className="sg-6"
      d="M461.25,239.82c-.54,2.53-4.81,4.93-8.45,6.68-2.79-4.9-6.02-8.22-10.19-11.64,1.83-3.2,3.91-7.35,5.6-7.77,3.46-.89,6.1-.8,9.05,1.19,2.95,1.99,4.98,6.87,3.99,11.54Z"
    />
    <path
      className="sg-1"
      d="M459.65,266.97h-.39c.37,1.04.56,2.14.56,3.27,0,7.41-8.31,11.34-18.69,11.34s-18.89-3.93-18.89-11.34c0-.04.05-.21,0-.43-.21-1.11-2.27-.79-3.9-.79s-3.69-.32-3.9.79c-.04.21,0,.38,0,.43,0,7.41-8.31,11.34-18.69,11.34s-18.89-3.93-18.89-11.34c0-1.13.2-2.22.56-3.27h-.51l-.07-1.81h82.79v1.81Z"
    />
    <line className="sg-4" x1={382.61} y1={268.87} x2={389.96} y2={277.87} />
    <line className="sg-4" x1={386.83} y1={268.87} x2={394.19} y2={277.87} />
    <line className="sg-4" x1={428.16} y1={268.87} x2={435.52} y2={277.87} />
    <line className="sg-4" x1={432.39} y1={268.87} x2={439.74} y2={277.87} />
  </svg>
);
export { SvgSunglasses };
